var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSound = function SvgSound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.515 15.94a1.576 1.576 0 0 1 1.94-1.534v-4.003c0-.278.189-.52.46-.588l5.03-1.252a.606.606 0 0 1 .752.588v5.476a.517.517 0 0 1 0 .04 1.576 1.576 0 1 1-1.212-1.534V9.927l-3.819.95V15.939a1.576 1.576 0 1 1-3.151 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.727 2.364a2.363 2.363 0 0 0-2.364 2.363v14.545a2.364 2.364 0 0 0 2.364 2.364h10.545a2.363 2.363 0 0 0 2.364-2.364V8.183a.606.606 0 0 0-.177-.428L14.245 2.54a.606.606 0 0 0-.429-.177h-7.09Zm-.814 1.549c.216-.216.509-.337.814-.337h6.84l4.857 4.858v10.838a1.152 1.152 0 0 1-1.152 1.152H6.727a1.151 1.151 0 0 1-1.152-1.152V4.727c0-.305.122-.598.338-.814Z"
  }))));
};
export default SvgSound;